// helpers.ts — Pure utility functions for FIN_BillData form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Status display map */
export const STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'O', label: 'O-未處理' },
  { value: 'A', label: 'A-已入帳' },
  { value: 'P', label: 'P-已兌現' },
  { value: 'Q', label: 'Q-退票' },
  { value: 'K', label: 'K-作廢' },
  { value: 'S', label: 'S-托收中' },
  { value: 'T', label: 'T-轉讓' },
];

/** BillType display map */
export const BILL_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'AP', label: 'AP-應付票據' },
  { value: 'AR', label: 'AR-應收票據' },
];

/** Check if record allows edit/delete per BR-003 */
export const canEditRecord = (status: string, billNo: string): boolean => {
  return status === 'A' || (status === 'O' && !billNo);
};

/** Determine fields that are always readonly */
const ALWAYS_READONLY = new Set([
  'bill_mid', 'bill_no', 'c_user', 'c_date', 'c_time', 'u_user', 'u_date',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};
